import InfoBanner from '@rsa-digital/evo-shared-components/components/InfoBanner';
import fonts from '@rsa-digital/evo-shared-components/helpers/fonts';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const StyledInfoBanner = styled(InfoBanner)`
  scroll-margin-top: ${spacing(11)};
`;

export const Heading = styled.h3`
  ${fonts.headingSmall}
`;
